export default function Footer() {
  const nav = [
    { href: "#hot", label: "正在热吃" },
    { href: "#channels", label: "频道目录" },
    { href: "#ranking", label: "热瓜榜单" },
    { href: "#why", label: "为何免费" },
    { href: "#faq", label: "常见问题" },
  ];
  const areas = ["综艺名场面", "明星红毯局", "影视幕后", "直播现场", "情感观察", "商界瓜铺"];

  return (
    <footer id="cta" className="bg-background-100 py-0">
      <div className="border-b border-background-200/70">
        <div className="mx-auto flex max-w-[1200px] flex-col items-center justify-between gap-4 px-4 py-10 text-center md:flex-row md:px-6 md:text-left">
          <div>
            <p className="font-heading text-2xl font-bold text-foreground-900">
              今天，也来吃口免费的瓜吗？
            </p>
            <p className="mt-2 text-sm text-foreground-600">一个页面全搞定，热门瓜料随时看，资源全解锁无门槛。</p>
          </div>
          <a
            href="#top"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            回到顶部，开始开吃
            <i className="ri-arrow-up-line" />
          </a>
        </div>
      </div>

      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-8 px-4 py-10 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <a href="#top" className="inline-flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
              瓜
            </span>
            <span className="font-heading text-xl font-bold text-foreground-900">吃瓜免费</span>
          </a>
          <p className="mt-4 max-w-sm text-xs leading-relaxed text-foreground-600">
            吃瓜免费资源聚合站，把最新热门瓜料、综艺名场面、明星动态与影视幕后汇到同一个页面，
            免登录、无门槛、全解锁，满足你的吃瓜需求，热门内容随时看。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold text-foreground-900">快速导航</h4>
          <ul className="mt-3 flex flex-col gap-2">
            {nav.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="text-xs text-foreground-600 transition-colors hover:text-primary-700">
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-foreground-900">热门频道</h4>
          <ul className="mt-3 flex flex-col gap-2">
            {areas.map((a) => (
              <li key={a}>
                <a href="#hot" className="text-xs text-foreground-600 transition-colors hover:text-primary-700">
                  {a}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="mx-auto flex max-w-[1200px] flex-col items-center justify-between gap-3 px-4 py-5 text-center sm:flex-row md:px-6 md:text-left">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 吃瓜免费 · 吃瓜免费资源聚合展示 · 免费全解锁
          </p>
          <p className="max-w-md text-[11px] leading-relaxed text-foreground-400">
            本站内容以公开信息整理聚合为主，仅供娱乐参考，请理性看待网络资讯，以官方与主流媒体发布为准。
          </p>
        </div>
      </div>
    </footer>
  );
}